module.exports = "/_next/static/images/404-9f8e6b7fba5fa65fe62843e7062faa1f.png";